import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const imperativeQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Selecciona la forma correcta del verbo en imperativo: '___ (comer) toda la comida antes de irte.'",
        options: ["Coma", "Come", "Comer", "Comerás"],
        correctAnswerIndex: 1,
        explanation: "'Come' es la forma en imperativo del verbo 'comer' para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Elige la opción correcta para dar una orden: '___ (hacer) tus tareas antes de jugar.'",
        options: ["Haz", "Hacer", "Hazte", "Haría"],
        correctAnswerIndex: 0,
        explanation: "'Haz' es el imperativo de 'hacer' para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Completa la oración con la forma correcta del verbo: '___ (cantar) en el escenario para la audición.'",
        options: ["Canta", "Cantará", "Canten", "Cantó"],
        correctAnswerIndex: 0,
        explanation: "'Canta' es el imperativo de 'cantar' para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Selecciona la opción correcta: '___ (escuchar) las instrucciones cuidadosamente antes de empezar.'",
        options: ["Escucha", "Escucharás", "Escuchas", "Escuchar"],
        correctAnswerIndex: 0,
        explanation: "'Escucha' es la forma en imperativo del verbo 'escuchar' para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Completa la frase con el imperativo adecuado: '___ (cerrar) la puerta antes de salir.'",
        options: ["Cierre", "Cierra", "Cerrando", "Cerrarás"],
        correctAnswerIndex: 1,
        explanation: "'Cierra' es la forma correcta de 'cerrar' en imperativo para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Elige la forma correcta del verbo en imperativo: '___ (leer) este libro para la próxima clase.'",
        options: ["Lea", "Lees", "Leí", "Lee"],
        correctAnswerIndex: 3,
        explanation: "'Lee' es el imperativo de 'leer' para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Elige la opción correcta: '___ (correr) más rápido en la próxima carrera.'",
        options: ["Corred", "Corren", "Correrán", "Corréis"],
        correctAnswerIndex: 0,
        explanation: "'Corred' es el imperativo de 'correr' para la segunda persona plural (vosotros)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Selecciona la opción correcta: '___ (no hablar) durante la película.'",
        options: ["No hablarás", "No habló", "No hables", "No hablaría"],
        correctAnswerIndex: 2,
        explanation: "'No hables' es la forma negativa en imperativo del verbo 'hablar' para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Elige la forma correcta del imperativo: '___ (ir) al médico si te sientes mal.'",
        options: ["Vaya", "Vas", "Ve", "Irás"],
        correctAnswerIndex: 2,
        explanation: "'Ve' es el imperativo de 'ir' para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Completa la frase: '___ (hacer) la cama antes de salir.'",
        options: ["Haz", "Hacer", "Hazte", "Haría"],
        correctAnswerIndex: 0,
        explanation: "'Haz' es la forma correcta de 'hacer' en imperativo para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Selecciona la opción correcta para dar una orden: '___ (ponerse) la chaqueta, que hace frío.'",
        options: ["Póntela", "Pónesela", "Ponla", "Te pone"],
        correctAnswerIndex: 0,
        explanation: "'Póntela' es la forma correcta del verbo 'ponerse' en imperativo para la segunda persona singular (tú), con pronombre enclítico."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Elige la forma correcta del verbo en imperativo: '___ (salir, usted) de la casa antes de las 9.'",
        options: ["Sal", "Salen", "Saldría", "Salga"],
        correctAnswerIndex: 3,
        explanation: "'Salga' es el imperativo del verbo 'salir' para la tercera persona singular (usted)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Completa la oración: '___ (venir, vosotros) a la reunión a las 10 de la mañana.'",
        options: ["Venid", "Vengan", "Vino", "Vendrán"],
        correctAnswerIndex: 0,
        explanation: "'Venid' es el imperativo de 'venir' para la segunda persona plural (vosotros)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Completa la oración con el imperativo adecuado: '___ (estudiar) más si quieres aprobar el examen.'",
        options: ["Estudias", "Estudia", "Estudiarás", "Estudiado"],
        correctAnswerIndex: 1,
        explanation: "'Estudia' es la forma correcta del verbo 'estudiar' en imperativo para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Completa la oración con el verbo en imperativo: '___ (trabajar) duro para conseguir tus objetivos.'",
        options: ["Trabajarás", "Trabajando", "Trabajaste", "Trabaja"],
        correctAnswerIndex: 3,
        explanation: "'Trabaja' es el imperativo de 'trabajar' para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Selecciona la opción correcta para dar una orden: '___ (sentarse) en la primera fila.'",
        options: ["Siéntate", "Sentarse", "Sentarás", "Sentada"],
        correctAnswerIndex: 0,
        explanation: "'Siéntate' es la forma en imperativo del verbo 'sentarse' para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Elige la forma correcta del verbo en imperativo: '___ (traer) los documentos mañana.'",
        options: ["Traerás", "Traído", "Trae", "Traer"],
        correctAnswerIndex: 2,
        explanation: "'Trae' es el imperativo de 'traer' para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Completa la frase con la forma correcta del verbo: '___ (prestar) atención durante la clase!'",
        options: ["Presta", "Prestó", "Prestarás", "Prestar"],
        correctAnswerIndex: 0,
        explanation: "'Presta' es el imperativo de 'prestar' para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Elige la forma correcta del verbo en imperativo: 'Señor, por favor ___ (trabajar) en este informe.'",
        options: ["Trabaje", "Trabajas", "Trabajaste", "Trabajaremos"],
        correctAnswerIndex: 0,
        explanation: "'Trabaje' es el imperativo afirmativo para 'usted.'"
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Selecciona la opción correcta para una orden negativa: '___ (no ir) al parque si está lloviendo.'",
        options: ["No vas", "No irás", "No vayas", "No voy"],
        correctAnswerIndex: 2,
        explanation: "'No vayas' es la forma negativa en imperativo del verbo 'ir' para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Selecciona la opción correcta: '___ (abrir) las ventanas por favor.'",
        options: ["Abrid", "Abren", "Abrirán", "Abrieron"],
        correctAnswerIndex: 0,
        explanation: "'Abrid' es el imperativo de 'abrir' para la segunda persona plural (vosotros)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Completa la frase con el verbo en imperativo: '___ (dormir) temprano si tienes clase mañana.'",
        options: ["Duerme", "Dormirás", "Durmió", "Dormir"],
        correctAnswerIndex: 0,
        explanation: "'Duerme' es el imperativo de 'dormir' para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Elige la forma correcta: '___ (hacer) la tarea antes de ver televisión.'",
        options: ["Hacer", "Harás", "Haz", "Hizo"],
        correctAnswerIndex: 2,
        explanation: "'Haz' es la forma en imperativo del verbo 'hacer' para la segunda persona singular (tú)."
    }
];

export default imperativeQuestions;